<template>
  <section>
    <el-table
      ref="table"
      :data="tableData"
      style="width: 100%"
      highlight-current-row
      :header-row-class-name="'tableHeader'"
      :row-style="rowClass"
      @row-click="rowClick">
      <el-table-column
        min-width="90px"
        label="创建日期">
        <template #default="{ row }">
          <span class="liter-time">{{ row.created_date }}</span>
        </template>
      </el-table-column>
      <el-table-column
        min-width="90px"
        label="生效日期">
        <template #default="{ row }">
          <span class="liter-time">{{ row.pcy_cmnt_date }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="名称"
      >
        <template #default="{ row }">
          <div class="flex-algin">
            <span>{{row.isrd_nm}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="120px"
        label="车牌号码">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="text-span">{{ row.rgtn_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        min-width="125px"
        label="车辆详情">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span
              class="first-text">{{`${row.rgtn_yr} ${row.brand} ${row.rgtn_mdl}` }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="证书号码"
        min-width="150px"
        :show-overflow-tooltip="true"
      >
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span
              class="first-text">{{ row.ci_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="保险计划"
        min-width="158px"
        :show-overflow-tooltip="true"
      >
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span
              class="first-text">{{ row.plan_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        min-width="120px"
      >
        <template #default="{ row }">
          <span :class="{'color-del':row.stts==0}">{{row.stts_language}}</span>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'ListTable',
  mixins: [MixinOptions],
  props:{
    tableData:{
      type: Array,
      default: () => []
    },
    isSme:{
      type:Boolean,
      default:false
    },
    isEnquiry:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      selectionTickets: [],
      selectRow:[],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('selectionChange',val)
    },

    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(row.id)) {
        return { 'background-color':' rgb(241,248,255)' }
      }
    },

    rowClick(row) {
      this.$emit('rowClick',row)
    },
    handlerBluePoint(id){
      this.$emit('point',id)
    },
    handleEnquiryMessage(id){
      this.$router.push({
        path:'/enquiry/detail',
        query:{
          id: id,
          tab:4
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      let path = '/tickets/detail'
      if(this.isSme){
        path =`/sme${path}`
      }
      if(this.isEnquiry)
      {
        path ='/enquiry/detail'
        return({
          path: path,
          query: {
            id: row.id
          }
        })
      }else
        return({
          path: path,
          query: {
            ticket_id: row.id
          }
        })
    },
  },
}
</script>
<style lang='scss' scoped>
.transparent {
  margin-top: 15px;
}
.blue-circle {
  position: relative;
  display: inline-block;
  margin-right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  left: -5px;
  &.blue{
    background: #409EFF;
  }
  &.yellow-circle{
    background: #DBAB09!important;
  }
  &::after {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  height: 45px;
  th {
    background-color:#F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    color: #24292E;
    height: 45px;
    .cell{
      height: 30px;
    }
  }
}
.span-status {
  margin-right: 5px;
  padding: 0 8px;
  border-radius: 25px;
  white-space: nowrap;

  height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #24292E;
  &.success {
    color:  rgb(67, 181, 92);
    background: rgb(220, 255, 228);
  }
  &.warning {
    background: rgb(255, 245, 177);
    color: rgb(218, 193, 93);
  }
  &.error {
    background: rgb(215, 58, 73);
    color: white;
  }
  &.warning-plain {
    border: 1px solid #B08800;
    color: #B08800;
  }
  &.unread-uplod {
    border: 1px solid #0366D6;
    color: #0366D6;
  }
  &.type-status{
    border: 1px solid #E1E4E8;
    color: #24292E;
  }
}
.status-height{
  height: 18px;
  line-height: 18px;
  padding: 0px 10px;
}
.status-two{
  border: 1px solid #0366D6;
  color: #0366D6;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.status-red{
  border: 1px solid #D73A49;
  color: #D73A49;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.status-yellow{
  border: 1px solid #DBAB09;
  color: #DBAB09;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.status-one{
  border: 1px solid #735C0F;
  color: #735C0F;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
}
.status-three
{
  border: 1px solid #22863A;
  color: #22863A;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
}
.span-status-stts{
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: inline-block;
  color: #FFFFFF;
  padding: 0px 8px;
  height: 18px;

  border-radius: 100px;
  &.orange-light {
    background: #E36209;
  }
  &.yellow-dark {
    background: #DBAB09;
  }
  &.blue {
    background: #0366D6;
  }
  &.green {
    background: #28A745;
  }
  &.red {
    background: #D73A49;
  }
  &.purple {
    background: #6F42C1;
  }

}
.flex-aglin{
  display: flex;
  flex-direction: column;
  justify-content:space-between ;
  p{
    height: 24px;
  }
  p:first-child{
    color: #24292E;
    font-size: 14px;
    font-weight: 600;
  }
}
.liter-text{
  color: #6A737D;
  font-family: Inter;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
  //height: 18px;
}

.text-right{
  position: absolute;
  z-index: 100;
  right: 1px;
  margin-top: 6px;
  height: 40px;
  width: 90%;
  background-color:#F6F8FA !important;
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    p,span{
      //height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
::v-deep .el-date-editor{
  width: 200px!important;
}
.showLick{
  color:  #000;
  text-decoration: none;
  &:hover{
    color:  #0366D6;
  }
}
.flex-algin {
  display: flex;
  flex-direction: column;
}
.height-36{
  span{
    height: 36px!important;
  }
}
.header-icon{
  height: 36px!important;
  width: 36px;
  border-radius: 25px;
  border:1px solid #CCD4E0;
  display: block;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content:center;
  cursor: pointer;
  img{
    width: 36px;
  }

}
///deep/.el-table .cell{
//  overflow: auto!important;
//}
.enquiry-icon-box{
  position: relative;
  height: 18px;
  width: 18px;
  margin-right: 8px;
  .enquiry-icon{
    font-size: 18px;
    color: #D1D5DA;
    cursor: pointer;
    &.yellow{
      color: #FFD33D;
    }
  }
  .right-dot{
    position: absolute;
    right: 0;
    top: -2px;
    .green{
      background: #28A745;
    }
  }
}
.span-label {
  display: block;
  color: #24292E;
  font-weight: 600;
  word-break: break-word;
  font-size: 14px;
  text-decoration: none;
}
.font-nomarl{
  font-weight: 400!important;
}
</style>
